// eslint-disable-next-line eslint-comments/disable-enable-pair
/* eslint-disable hydrogen/prefer-image-component */
import type {MediaEdge} from '@shopify/hydrogen/storefront-api-types';
// @ts-ignore
import {Navigation, Controller, FreeMode, SwiperClass} from 'swiper';
// @ts-ignore
import {Swiper, SwiperSlide} from 'swiper/react';
import clsx from 'clsx';
import {Modal} from '../Modal.client';
import {useState} from 'react';
import {IconArrow} from '../icons/IconArrow';
import iconCheck from '../../assets/icons/icon-check.svg';
import iconPlay from '../../assets/icons/icon-play.svg';
import {ProductGalleryAsset} from './ProductGalleryAsset.client';
import {DATA_TEST_IDS} from '~/lib/const';

export function ProductGalleryModal({
  index,
  media,
  open,
  onCloseModal,
}: {
  index: number;
  media: MediaEdge['node'][];
  open: boolean;
  onCloseModal: () => void;
}) {
  const [swiper, setSwiper] = useState<SwiperClass>({});
  const [thumbsSwiper, setThumbsSwiper] = useState({});

  const [activeIndex, setActiveIndex] = useState(0);

  return (
    <Modal
      isOpen={open}
      onCloseModal={onCloseModal}
      classNamePanel="p-10 pb-[84px] max-h-[90vh] max-w-[90vw] aspect-square w-full h-full"
      classNameContent="h-full pb-10"
      hideVerticalMargin
    >
      <div className="grid grid-cols-1 grid-rows-6 overflow-hidden h-full">
        <div className="flex items-center mt-10 gap-11 row-span-5">
          <button
            type="button"
            className={clsx(
              'w-12 h-12 rounded-full flex items-center justify-center border-2 border-blue-500 group cursor-pointer flex-shrink-0 mt-[26px]',
              'enabled:hover:bg-blue-500 enabled:hover:text-white',
            )}
            onClick={() => swiper?.slidePrev()}
          >
            <IconArrow className="w-[8.48px] h-[16.06px] rotate-180" />
          </button>

          <Swiper
            onSwiper={(s) => {
              setSwiper(s);

              setTimeout(() => {
                s?.slideTo(index);
                setActiveIndex(index);
              }, 100);
            }}
            // @ts-expect-error
            modules={[Navigation, FreeMode, Controller]}
            controller={{control: thumbsSwiper}}
            onSlideChange={(swiper) => setActiveIndex(swiper.activeIndex)}
            className={'relative h-full'}
            effect="fade"
            centeredSlides
            allowTouchMove={true}
            slidesPerView={1}
            cssMode={false}
            shortSwipes={true}
            threshold={10}
          >
            {media?.map((med, index) => (
              <SwiperSlide
                // @ts-ignore
                key={med.id || med.image.id}
              >
                <div className="h-full">
                  <ProductGalleryAsset
                    media={med}
                    index={index}
                    videoControls={1}
                    videoNotInteractive={false}
                  />
                </div>
              </SwiperSlide>
            ))}
          </Swiper>

          <button
            data-testid={DATA_TEST_IDS.BUTTON('next')}
            type="button"
            className={clsx(
              'w-12 h-12 rounded-full flex items-center justify-center border-2 border-blue-500 group cursor-pointer flex-shrink-0 mt-[26px]',
              'enabled:hover:bg-blue-500 enabled:hover:text-white',
            )}
            onClick={() => swiper?.slideNext()}
          >
            <IconArrow className="w-[8.48px] h-[16.06px]" />
          </button>
        </div>

        <div className="mx-[91px] h-full flex items-end">
          <Swiper
            onSwiper={setThumbsSwiper}
            // @ts-ignore
            spaceBetween={10}
            slidesPerView={'auto'}
            freeMode={true}
            watchSlidesProgress
            modules={[FreeMode, Navigation, Controller]}
            controller={{control: swiper}}
            className="mySwiper h-full max-h-[90px]"
          >
            {media?.map((med, index) => (
              <SwiperSlide
                // @ts-ignore
                key={med.id || med.image.id}
                style={{
                  width: '90px',
                }}
              >
                <button
                  data-testid={DATA_TEST_IDS.BUTTON('prev')}
                  type="button"
                  // @ts-ignore
                  onClick={() => swiper?.slideTo(index)}
                  className={clsx(
                    'relative border-2 h-full',
                    index === activeIndex ? 'border-blue-500' : 'border-white',
                  )}
                >
                  <ProductGalleryAsset media={med} index={index} isThumbnail />

                  {index === activeIndex ? (
                    <div className="w-10 h-10 rounded-full bg-blue-500 grid place-items-center absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2">
                      <img loading="lazy" src={iconCheck} alt="Selected" />
                    </div>
                  ) : (
                    (med.mediaContentType === 'VIDEO' ||
                      med.mediaContentType === 'EXTERNAL_VIDEO') && (
                      <div className="w-10 h-10 absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2">
                        <img loading="lazy" src={iconPlay} alt="Video" />
                      </div>
                    )
                  )}
                </button>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </div>
    </Modal>
  );
}
